import { Component, OnInit, ViewChild } from '@angular/core'
import { SelectItem } from 'primeng/api'
import { AceComponent, AceConfigInterface } from 'ngx-ace-wrapper'
import 'brace'
import 'brace/mode/json'
import 'brace/theme/github'

import { Store, select } from '@ngrx/store'
import { RootStoreState } from '../../root-store/root-index'
import * as fromConfigSelectors from '../../root-store/config-store/config.selectors'
import { EntityService } from '../../modules/dto'
import { NotificationService } from '../../services/notification.service'
import { JmlTitleService } from '../../services/jml-title.service'

@Component({
  selector: 'jml-lib-dtoconfig-editor',
  templateUrl: './dtoconfig-editor.component.html',
  styleUrls: ['./dtoconfig-editor.component.scss']
})
export class DTOConfigEditorComponent implements OnInit {
  @ViewChild(AceComponent) componentRef?: AceComponent

  dtoConfigs: SelectItem[]
  currentConfig: string
  currentConfigName: string
  enableEditor = false

  public aceconfig: AceConfigInterface = {
    mode: 'json',
    theme: 'github',
    readOnly: false
  }

  constructor(
    private entityService: EntityService,
    private notificationService: NotificationService,
    private store$: Store<RootStoreState.State>,
    private titleService: JmlTitleService
  ) {}

  configToSelectItem(name: string, type: string): SelectItem {
    return { label: name, value: type }
  }

  ngOnInit() {
    this.titleService.setAppTitle('DTO Konfiguration')
    const configurations$ = this.store$.pipe(select(fromConfigSelectors.selectConfigs))
    configurations$.subscribe((configs) => {
      if (configs) {
        this.dtoConfigs = Object.values(configs)
          .map((config) => this.configToSelectItem(config.type, config.type))
          .sort((a, b) => a.label.localeCompare(b.label))
      }
    })
  }

  selectedConfigChanged(event) {
    this.enableEditor = true
    this.currentConfigName = event['value']
    this.entityService
      .getEntityConfigurationFile(this.currentConfigName)
      .subscribe((config) => (this.currentConfig = config['content']))
  }

  saveConfig() {
    this.entityService
      .updateEntityConfigurationFile(this.currentConfigName, this.currentConfig)
      .subscribe(() => this.notificationService.addSuccessNotification('Konfiguration erfolgreich gespeichert.'))
  }

  public onEditorBlur(event: any): void {
    // console.log('Editor blur:', event);
  }

  public onEditorFocus(event: any): void {
    // console.log('Editor focus:', event);
  }

  public onValueChange(value: string): void {
    // console.log('Value change:', value);
  }

  public onContentChange(event: any): void {
    // console.log('Content change:', event);
  }

  public onSelectionChange(event: any): void {
    // console.log('Selection change:', event);
  }
}
